import { BodyProfileHint } from "@/lib/health/use-body-profile";
import { m } from "@/paraglide/messages";
import { getLocale } from "@/paraglide/runtime";
import { healthyWeightRange } from "../lib/health";
import { HealthDisclaimer } from "./HealthDisclaimer";
import { HeightInput, UnitsToggle } from "./inputs";
import { useBody } from "./useBody";

export function HealthyWeightCalc() {
  const b = useBody();
  const locale = getLocale();
  const range = healthyWeightRange(b.heightCm);

  const toDisplay = (kg: number) =>
    (b.units === "metric" ? kg : kg / 0.45359237).toLocaleString(locale, {
      maximumFractionDigits: 1,
    });
  const unitLabel = b.units === "metric" ? m.bmi_unit_kg() : m.bmi_unit_lb();

  return (
    <div className="rounded-2xl border border-border bg-card/60 p-6 sm:p-8">
      <div className="mb-5">
        <UnitsToggle value={b.units} onChange={b.setUnits} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <HeightInput
          units={b.units}
          cm={b.cm}
          ft={b.ft}
          inch={b.inch}
          onCm={b.setCm}
          onFt={b.setFt}
          onInch={b.setInch}
          idPrefix="hw"
        />
      </div>

      <div className="mt-6" aria-live="polite">
        {range === null ? (
          <p className="text-sm text-muted-foreground">{m.hw_enter()}</p>
        ) : (
          <div className="rounded-xl bg-primary/10 p-5 text-center">
            <p className="text-xs uppercase tracking-wide text-muted-foreground">
              {m.hw_result_label()}
            </p>
            <p
              data-testid="hw-range"
              className="mt-1 font-display text-2xl font-bold tabular-nums text-primary"
            >
              {m.hw_range({
                min: toDisplay(range.min),
                max: toDisplay(range.max),
                unit: unitLabel,
              })}
            </p>
          </div>
        )}
      </div>

      <BodyProfileHint {...b.profileSync} />

      <HealthDisclaimer />
    </div>
  );
}
